<div class="container">
  <h2 class="main-title"><span fiTranslation="ADMINISTRATION_DUPLICATES_OVERVIEW"></span></h2>
</div>

<ng-template #search>
  <div class="search-container" [class.show]="searchFilterOpen" [class.shift-to-left]="shiftToLeft">
    <div class="search-field">
      <form class="search-form" (submit)="addFilter(filterType, searchInput.value)">
        <input maxlength="500" #searchInput id="{{filterType}}" type="search" class="search-input" fiTranslation="SEARCH_PLACEHOLDER"
          [isPLaceHolder]="true" value="">
        </form>
      </div>
      @if (searchInput.value) {
        <div class="clear-input">
          <img alt="Close" src="/assets/icons/close-icon.svg" (click)="searchInput.value = ''">
        </div>
      }
    </div>
  </ng-template>

  <ng-template #multiselect>
    <div fiCustomSelect
      (value)="onMultiselectChanged($event)"
      [data]="multiselectOptions"
      [isMultiSelect]="true"
      [selectedData]="selectedMultiselectOptions"
      [dataValueKey]="'value'"
      [dataNameKey]="'label'"
      class="select-type select input-field" id="{{filterType}}" [class.shift-to-left]="shiftToLeft">
      <span class="selected-value placeholder"></span>
      <div class="options-cont large">
        <ul class="options"></ul>
      </div>
    </div>
  </ng-template>

  <div class="table-container f_table-container">
    <table class="main-table">
      <thead>
        @if (filters.length) {
          <tr class="filters">
            <td colspan="12">
              <div class="sort-tabs">
                @for (filter of filters; track filter; let i = $index) {
                  <span>
                    {{ filter.value }}
                    <mat-icon (click)="deleteFilter(i)">close</mat-icon>
                  </span>
                }
                <span class="remove-all">
                  <span fiTranslation="REQUEST_OVERVIEW_FILTER_CANCEL"></span>
                  <mat-icon (click)="clearFilters()">close</mat-icon>
                </span>
              </div>
            </td>
          </tr>
        }

        <tr>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_TYPE"></span><img src="assets/icons/drop-down-arrow.svg" alt="icon" class="arrow custom" (click)="openMultiselectFilter('TYPE', $event)">
            @if (filterType === 'TYPE') {
              <ng-container *ngTemplateOutlet="multiselect"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_NUMBER"></span><img src="assets/icons/search-loop.svg" alt="icon" class="search-loop" (click)="openSearchFilter('NUMBER', $event)">
            @if (filterType === 'NUMBER') {
              <ng-container *ngTemplateOutlet="search"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_LAST_NAME"></span><img src="assets/icons/search-loop.svg" alt="icon" class="search-loop" (click)="openSearchFilter('LAST_NAME', $event)">
            @if (filterType === 'LAST_NAME') {
              <ng-container *ngTemplateOutlet="search"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_FIRST_NAME"></span><img src="assets/icons/search-loop.svg" alt="icon" class="search-loop" (click)="openSearchFilter('FIRST_NAME', $event)">
            @if (filterType === 'FIRST_NAME') {
              <ng-container *ngTemplateOutlet="search"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_EMAIL"></span><img src="assets/icons/search-loop.svg" alt="icon" class="search-loop" (click)="openSearchFilter('EMAIL', $event)">
            @if (filterType === 'EMAIL') {
              <ng-container *ngTemplateOutlet="search"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_DATE"></span><img src="assets/icons/drop-down-arrow.svg" alt="icon" class="arrow custom" (click)="openMultiselectFilter('DATE', $event)">
            @if (filterType === 'DATE') {
              <ng-container *ngTemplateOutlet="multiselect"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_RESPONSIBLE"></span><img src="assets/icons/drop-down-arrow.svg" alt="icon" class="arrow custom" (click)="openMultiselectFilter('EDITOR', $event)">
            @if (filterType === 'EDITOR') {
              <ng-container *ngTemplateOutlet="multiselect"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_CREATOR"></span><img src="assets/icons/drop-down-arrow.svg" alt="icon" class="arrow custom" (click)="openMultiselectFilter('CREATOR', $event)">
            @if (filterType === 'CREATOR') {
              <ng-container *ngTemplateOutlet="multiselect"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_TEXT"></span><img src="assets/icons/search-loop.svg" alt="icon" class="search-loop" (click)="openSearchFilter('TEXT', $event)">
            @if (filterType === 'TEXT') {
              <ng-container *ngTemplateOutlet="search"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_ORIGIN"></span><img src="assets/icons/drop-down-arrow.svg" alt="icon" class="arrow custom" (click)="openMultiselectFilter('SOURCE', $event)">
            @if (filterType === 'SOURCE') {
              <ng-container *ngTemplateOutlet="multiselect"></ng-container>
            }
          </th>
          <th>
            <span fiTranslation="ADMINISTRATION_DUPLICATES_TABLE_COUNTRY"></span><img src="assets/icons/drop-down-arrow.svg" alt="icon" class="arrow custom" (click)="openMultiselectFilter('COUNTRY', $event)">
            @if (filterType === 'COUNTRY') {
              <ng-container *ngTemplateOutlet="multiselect"></ng-container>
            }
          </th>
        </tr>

      </thead>
      <tbody>
        @for (duplicate of duplicates; track duplicate; let i = $index) {
          @if (passesFilter(duplicate)) {
            <tr>
              <td class="one-line"
                #typeCol matTooltip="{{typeCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'TYPE') }}
              </td>
              <td class="one-line" #numberCol matTooltip="{{numberCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'NUMBER') }}
              </td>
              <td class="one-line" #firstNameCol matTooltip="{{firstNameCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'FIRST_NAME') }}
              </td>
              <td class="one-line" #lastNameCol matTooltip="{{lastNameCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'LAST_NAME') }}
              </td>
              <td class="one-line" #emailCol matTooltip="{{emailCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'EMAIL') }}
              </td>
              <td class="one-line" #dateCol matTooltip="{{dateCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'DATE') }}
              </td>
              <td class="one-line" #editorCol matTooltip="{{editorCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'EDITOR') }}
              </td>
              <td class="one-line" #creatorCol matTooltip="{{creatorCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'CREATOR') }}
              </td>
              <td class="one-line long" #textCol matTooltip="{{textCol.innerText}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-3'
                >
                <span class="is-html-snippet" [innerHTML]="getValue(duplicate, 'TEXT')"></span>
              </td>
              <td class="one-line" #sourceCol matTooltip="{{sourceCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'SOURCE') }}
              </td>
              <td class="one-line long" #countryCol matTooltip="{{countryCol.textContent}}"
                matTooltipPosition="below"
                matTooltipClass='tooltip-style overflow-2'
                >
                {{ getValue(duplicate, 'COUNTRY') }}
              </td>
            </tr>
          }
        }

      </tbody>
    </table>
    @if (isTableEmpty) {
      <div class="empty-message" fiTranslation="ADMINISTRATION_DUPLICATES_NO_DUPLICATES"></div>
    }
  </div>

